export function vlozitDoKosikuSamoobsluha(polozka) {
  return { type: "ADDSAMOOBSLUHA", payload: polozka };
}
